var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card-header pl-0" }, [
      _c(
        "div",
        { staticClass: "d-flex justify-content-between align-items-center" },
        [
          _c("div", { staticClass: "dropdown mr-3 d-none" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "dropdown-menu",
                attrs: { "aria-labelledby": "inspectorDropdown" }
              },
              [
                _c("li", { staticClass: "d-none" }, [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "default"
                        }
                      }
                    },
                    [_vm._v("Default")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "main"
                        }
                      }
                    },
                    [_vm._v("Main")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "animations"
                        }
                      }
                    },
                    [_vm._v("Animations")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "light"
                        }
                      }
                    },
                    [_vm._v("Light")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "sound"
                        }
                      }
                    },
                    [_vm._v("Sound")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "movement"
                        }
                      }
                    },
                    [_vm._v("Movement")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "effects"
                        }
                      }
                    },
                    [_vm._v("Effects")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "tts"
                        }
                      }
                    },
                    [_vm._v("TTS")]
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("span", { staticClass: "text-primary ml-3" }, [
            _vm._v("\n        " + _vm._s(_vm.activeComponentTitle) + "\n      ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dropdown ml-5 d-none" }, [
            _vm._m(2),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "dropdown-menu",
                attrs: { "aria-labelledby": "inspectorDropdown2" }
              },
              [
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "object 3d"
                        }
                      }
                    },
                    [_vm._v("Object 3d")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "environment 3d"
                        }
                      }
                    },
                    [_vm._v("Environment 3D")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "media-sounds"
                        }
                      }
                    },
                    [_vm._v("Media-Sounds")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "media-videos"
                        }
                      }
                    },
                    [_vm._v("Media-Videos")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "media-images"
                        }
                      }
                    },
                    [_vm._v("Media-Images")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "ds-dynamic text"
                        }
                      }
                    },
                    [_vm._v("DS-Dynamic Text")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "ds-object 2d"
                        }
                      }
                    },
                    [_vm._v("DS-Object 2D")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "standalone lighting"
                        }
                      }
                    },
                    [_vm._v("Standalone Lighting")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "standalone effects"
                        }
                      }
                    },
                    [_vm._v("Standalone Effects")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "object 2D"
                        }
                      }
                    },
                    [_vm._v("Object 2D")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "wof"
                        }
                      }
                    },
                    [_vm._v("WOF")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "chatbot"
                        }
                      }
                    },
                    [_vm._v("Chatbot")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "verbal-speech"
                        }
                      }
                    },
                    [_vm._v("Verbal-Speech")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "probability"
                        }
                      }
                    },
                    [_vm._v("Probability")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "trivia"
                        }
                      }
                    },
                    [_vm._v("Trivia")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "touch 2D"
                        }
                      }
                    },
                    [_vm._v("Touch 2D")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "touch 3D"
                        }
                      }
                    },
                    [_vm._v("Touch 3D")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "event"
                        }
                      }
                    },
                    [_vm._v("Event")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "universal conditions"
                        }
                      }
                    },
                    [_vm._v("Universal Conditions")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "universal filtering"
                        }
                      }
                    },
                    [_vm._v("Universal Filtering")]
                  )
                ])
              ]
            )
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _vm._m(3)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-card-header dropdown-toggle",
        attrs: {
          type: "button",
          id: "inspectorDropdown",
          "data-toggle": "dropdown",
          "aria-expanded": "false"
        }
      },
      [
        _c("img", {
          staticClass: "heading-icon mr-2",
          attrs: { src: require("@/assets/addplus_icon.svg") }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "pr-2 text-capitalize" }, [_vm._v(" Add")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "ml-3" }, [
      _c("img", {
        staticClass: "heading-icon mr-2",
        attrs: { src: require("@/assets/device_hub_icon.svg") }
      }),
      _vm._v(" Inspector")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-dark dropdown-toggle",
        attrs: {
          type: "button",
          id: "inspectorDropdown2",
          "data-toggle": "dropdown",
          "aria-expanded": "false"
        }
      },
      [
        _c("img", {
          staticClass: "heading-icon mr-2",
          attrs: { src: require("@/assets/addplus_icon.svg") }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "pr-2 text-capitalize" }, [_vm._v(" Others")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "inspector-wrapper" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e4db5660", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4db5660","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/story-edit-view/inspector-wrap/experienceInspector.vue
// module id = null
// module chunks = 